const clearCache = (
  keys = [
    'slotTimeId',
    'conman',
    'reBooking',
    '_dataFinishBooking',
    '_dataRegisterRoom',
    '_bookingNumber',
    '__session__',
    '_data',
    'apiToken',
    '_reBookingStep',
    '_bookingStep'
  ]
) => {
  keys.forEach(key => localStorage.removeItem(key));
};

export default clearCache;
